import React, { useState } from 'react';
import { PasswordBox, TextBoxLayoutStyle } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const PasswordBoxPanel: React.FC = () => {
    const [password, set_password] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>Password Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <PasswordBox
                    id='password'
                    name='password'
                    value={password}
                    onChange={set_password}
                    label='Password'
                    required={true}
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PasswordBox
                    id='password'
                    name='password'
                    value={password}
                    onChange={set_password}
                    label='Password'
                    required={true}
                    showInfoIcon={true}
                    infoText='Your password'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PasswordBox
                    id='password'
                    name='password'
                    value={password}
                    onChange={set_password}
                    label='Password (Horiz.)'
                    required={true}
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='130px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <PasswordBox
                    id='password'
                    name='password'
                    value={password}
                    onChange={set_password}
                    label='Password (Horiz.)'
                    required={true}
                    showInfoIcon={true}
                    infoText='Your password'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='160px'
                />
            </div>
        </>
    );
};
